/*
import {
  hf,
  ht,
  cr,
  a,
  BoxC,
  BtnC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as BtnC from "./_cccBtnC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';
import * as hf from './_hf';

import * as IccvCtt from './icvI1z___TzCtt';

export const N = (pz: {
  sPz: ht.dz,
  cz: {
    i1zz: ht.dz,
  },
}) => {

  let _zone = '';
  let _nFeeTtl = 0;
  const _feez = {} as ht.dz;
  pz.cz.i1zz.i1z1s.map((_i1z1z: ht.dz) => {
    if (hf.f(_zone)) _zone += `\n`;
    _zone += `${_i1z1z.i1z1a2200s}（${_i1z1z.i1z1a1100i}時〜${_i1z1z.i1z1a1200i}時）`; 
    if (!_feez[_i1z1z.i1z1a2100s]) _feez[_i1z1z.i1z1a2100s] = 0; 
    _feez[_i1z1z.i1z1a2100s] += _i1z1z.i1z1m1100i;
    _nFeeTtl += _i1z1z.i1z1m1100i;
  });
  let _room = '';
  Object.keys(_feez).map((_roomName: ht.s) => {
    if (hf.f(_room)) _room += `\n`;
    _room += `${_roomName}（${hf.cvtCmm(_feez[_roomName])}円）`
  });

  return (

    cr.c(BoxC.N, {
      key: -10,
      abtType: 'baseAreaz',
      oClds: [

        cr.c(BoxC.N, {
          key: -10,
          abtType: 'topAreaz',
          oClds: [

            cr.c(TextC.N, {
              key: -10,
              abtType: 'msgz',
              textz: {
                pfx: `${pz.sPz.crt.dffz.tgt}が完了しました。`,
              }
            })

          ]
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'mainAreaz',
          boxStlz: a(`sc/${pz.sPz.crt.dffz.clr}1`),
          oClds: [

            cr.c(IccvCtt.N, {
              key: -10,
              sPz: pz.sPz,
              cz: {
                i1zz: pz.cz.i1zz,
                clr: pz.sPz.crt.dffz.clr,
              },
              boxStlz: a('mb/4'),
            })

          ]
        }),

        cr.c(BoxC.N, {
          key: -30,
          abtType: 'btnAreaz',
          oClds: [

            pz.sPz.crt.ctt == 'r' ?
            cr.c(BtnC.N, {
              key: -10,
              abtType: 'homez',
              lblCz: {
                textz: {
                  pfx: `同じ部屋を\n別の条件で予約`,
                },
              },
              pslPtyz: {
                onPress: () => {
                  pz.sPz.set({
                    steps: [1, 0],
                    phs: 'crt',
                  });
                },
              },
            })
            : undefined,

            cr.c(BtnC.N, {
              key: -20,
              abtType: 'homez',
              boxStlz: a(`sc/${pz.sPz.crt.dffz.clr}7`),
              lblCz: {
                textz: {
                  pfx: `[利用予約]\n最初の画面に戻る`,
                  stlz: a(`tc/lt1`),
                },
              },
              pslPtyz: {
                onPress: () => {
                  pz.sPz.set({
                    steps: [0, 0],
                    phs: 'dpy',
                  })
                },
              },
            })

          ],
        })

      ]
    })
  );
};
